import { cn } from "../../utils/tailwindUtils";

const STATUS_META = {
    draft: { label: "Draft", className: "bg-gray-100 text-gray-700 dark:bg-gray-700/40 dark:text-gray-200" },
    in_progress: { label: "In Progress", className: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300" },
    pending_employee_submission: { label: "Pending Submission", className: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300" },
    submitted_to_rm: { label: "Submitted to RM", className: "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300" },
    sent_back_by_rm: { label: "Sent Back by RM", className: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300" },
    rm_reviewed: { label: "RM Reviewed", className: "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300" },
    pending_hr_approval: { label: "Pending HR Approval", className: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300" },
    sent_back_by_hr: { label: "Sent Back by HR", className: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300" },
    hr_approved: { label: "HR Approved", className: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300" },
    published: { label: "Published", className: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300" },
    closed: { label: "Closed", className: "bg-slate-200 text-slate-700 dark:bg-slate-700/40 dark:text-slate-200" },
    overdue: { label: "Overdue", className: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300" },
};

const StatusPill = ({ value, className }) => {
    const meta = STATUS_META[value] || { label: value || "—", className: "bg-gray-100 text-gray-700" };
    return (
        <span className={cn("inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap", meta.className, className)}>
            {meta.label}
        </span>
    );
};

export { STATUS_META };
export default StatusPill;
